import InvoicesAPI from '../../../../api/Sales/Invoices'
import Status from '../../../../elements/Status'
import { dateFormat, moneyColumn } from '../../../../modules/Utils'
import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { Button, Checkbox, message, Popconfirm, Popover, Steps } from 'antd'
import Options from '../../../../components/Finance/Reports/steps/Options'
import Preview from '../../../../components/Finance/Reports/steps/Preview'
import ExportCSV from '../../../../components/Finance/Reports/steps/ExportCSV'
import { Link } from 'react-router-dom'
import './style.css'
import downloadCsv from 'download-csv'
import _ from 'lodash'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import DateFilter, { dateFilterMethod } from '../../../../elements/Table/Filters/Date'

const Step = Steps.Step

class ExportCSVComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      current: 0,
      list: {},
      formValues: {},
      columns: [
        {
          Header: 'Code',
          accessor: 'code',
          Cell: ({ original, value }) => {
            return (
              <Link target={'_blank'} to={`/clients/invoices/${original._key}/view`} style={{ marginLeft: '10px' }}>
                {value}
              </Link>
            )
          },
        },
        {
          Header: 'Invoice Date',
          accessor: 'date',
          Cell: ({ value }) => value && dateFormat(moment(value)),
        },
        {
          Header: 'Changes Since Export',
          accessor: 'export.rev',
          zIndex: -99,
          Cell: ({ original, value }) => (
            <Status tooltip={false} value={value ? (original._rev === value ? 'Latest' : 'Changed') : 'New'}/>
          ),
        },
        {
          Header: 'Client',
          accessor: 'client.fn',
          width: 300,
        },
        {
          Header: 'MAC',
          accessor: 'activity.code',
          hideable: true,
          hideDefault: true,
        },
        {
          Header: 'Contract',
          accessor: 'contract.code',
        },
        {
          Header: 'Sales',
          accessor: 'order.code',
        },
        {
          Header: 'Currency',
          accessor: 'currency',
        },
        {
          Header: 'Amount',
          accessor: 'subtotal.net',
          style: { textAlign: 'right' },
          Cell: ({ value }) => moneyColumn(value),
        },
        {
          Header: 'Status',
          accessor: 'status',
          Cell: ({ original, value }) => <Status tooltip={false} value={value}/>,
        },
        {
          Header: 'Issue Date',
          accessor: 'issuance.date',
          Cell: ({ value }) => value && dateFormat(moment(value)),
          hideable: true,
          hideDefault: true,
        },
        {
          Header: 'Issued',
          accessor: 'issuance.issued',
          Cell: ({ value }) => value && <Checkbox checked={value}/>,
          hideable: true,
          hideDefault: true,
        },
        {
          Header: 'Created Date',
          accessor: '_history.created.date',
          Cell: DateCell,
          Filter: DateFilter,
          filterMethod: dateFilterMethod,
          hideable: true,
          // hideDefault: true,
        },
      ],
    }
  }

  optionsRef = React.createRef()
  api = new InvoicesAPI()

  next = async () => {
    if (this.state.current === 0) await this.onSubmitOptions()
    const current = this.state.current + 1
    this.setState({ current })
  }

  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }

  approve = async () => {
    try {
      const exportInvoices = await this.api.export({ list: this.state.list })
      if (!exportInvoices) throw 'Problem with export api'

      const newColumnsList = this.state.columns.filter((c) => this.state.desiredColumns.includes(c.accessor))

      const csvSelection = this.state.list.map((l) => {
        let temp = {}
        newColumnsList.forEach((dc) => (temp[dc.Header] = _.get(l, dc.accessor)))
        return temp
      })
      downloadCsv(csvSelection, Object.keys(csvSelection[0]))
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
  }

  onSubmitOptions = async () => {
    const values = await this.checkForm(this.optionsRef)
    const list = await this.props.fetch(values)
    const desiredColumns = values.columns
    this.setState({ list, desiredColumns, formValues: values })
  }

  checkForm = (currentRef) => {
    return new Promise((res, rej) => {
      currentRef.current.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  render () {
    const { current } = this.state

    const customDot = (dot, { status, index }) => (
      <Popover
        content={
          <span>
            Step {index + 1} status: {status}
          </span>
        }>
        {dot}
      </Popover>
    )

    const StepsAction = () => (
      <div className="center_modal">
        {current > 0 && (
          <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
            Previous
          </Button>
        )}

        {current < steps.length - 1 &&
        (steps[current].confirmation ? (
          <Popconfirm
            title={steps[current].confirmation}
            onConfirm={() => this.next()}
            okText="Create"
            cancelText="Cancel"
            style={{ marginLeft: 17 }}>
            <Button type="primary" style={{ marginLeft: 17 }}>
              {steps[current].nextText ? steps[current].nextText : 'Next'}
            </Button>
          </Popconfirm>
        ) : (
          <Button type="primary" style={{ marginLeft: 17 }} onClick={() => this.next()}>
            {steps[current].nextText ? steps[current].nextText : 'Next'}
          </Button>
        ))}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => this.approve()} style={{ marginLeft: 17 }}>
            Download CSV
          </Button>
        )}
      </div>
    )

    const steps = [
      {
        title: 'Options',
        content: (
          <Options
            {...this.props}
            formValues={this.state.formValues}
            onSubmit={this.onSubmitOptions}
            ref={this.optionsRef}
            columns={this.state.columns}
          />
        ),
        nextText: 'Search',
      },
      {
        title: 'Preview',
        content: (
          <Preview
            {...this.props}
            list={this.state.list}
            desiredColumns={this.state.desiredColumns}
            columns={this.state.columns}
          />
        ),
      },
      {
        title: 'Export CSV',
        content: <ExportCSV {...this.props} />,
      },
    ]

    const StepsProgressDots = () => (
      <Steps current={current} progressDot={customDot}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title}/>
        ))}
      </Steps>
    )
    return (
      <Fragment>
        <StepsProgressDots/>
        <StepsAction/>
        <Fragment className="steps-content">{steps[current].content}</Fragment>
      </Fragment>
    )
  }
}

export default ExportCSVComponent
